// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.features-list{display:flex;flex-wrap:wrap}}.features-list__item{display:block;font-size:14px;line-height:18px;color:var(--1uzdt74)}@media only screen and (min-width:992px){.features-list__item{margin-right:16px}}.features-list__item-value{color:var(--z2kad5)}", ""]);
// Exports
module.exports = exports;
